import React from 'react';
import { useTranslation } from 'react-i18next';
import { Heading } from '../../../../atoms';
import { Icon } from '@chargify/icons';
import { Wrapper } from './StatusMsg.styles';
import { Status } from '../../types';

type Props = {
  status: Status;
  customMessages?: { [key in Status]: string };
};

export const StatusMsg = ({ status, customMessages }: Props) => {
  const { t } = useTranslation(['payment-profile']);
  const statusMsg: Record<Status, string> = {
    active: t('active_payment'),
    error: t('expired_card'),
    unavailable: t('unavailable'),
    ...customMessages,
  };
  const getStatusIcon = (status: Status) => {
    switch (status) {
      case 'active':
        return <Icon fill={'success.main'} type={'circleCheck'} size={16} />;
      case 'error':
        return <Icon fill={'danger.main'} type={'circleCross'} size={16} />;
      case 'unavailable':
        return <Icon fill={'danger.light'} type={'circleInfo'} size={16} />;
      default:
        return null;
    }
  };
  const getMsgColor = (status: Status) => {
    if (status === 'active') {
      return 'success.main';
    }
    if (status === 'error') {
      return 'danger.main';
    }
    if (status === 'unavailable') {
      return 'danger.light';
    }
  };
  return (
    <Wrapper>
      {getStatusIcon(status)}
      <Heading variant={'h5'} color={getMsgColor(status)}>
        {statusMsg[status]}
      </Heading>
    </Wrapper>
  );
};
